// src/api/BrandAPIs.js
import { getToken } from "../utils/auth";

import { API_BASE_URL } from './URL_Header';

export const fetchBrands = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/Brand/GetAllBrands`);
    if (!response.ok) throw new Error("Failed to fetch brands");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchBrandById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Brand/GetBrand/${id}`);
    if (!response.ok) throw new Error("Failed to fetch brand");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchTypesForBrand = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Brand/GetAllTypesForBrand/${id}`
    );
    if (!response.ok) throw new Error("Failed to fetch types for brand");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const createBrand = async (brand) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Brand/AddBrand`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(brand),
    });
    if (!response.ok) throw new Error("Failed to create brand");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const updateBrand = async (id, brand) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Brand/EditBrand/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(brand),
    });
    if (!response.ok) throw new Error("Failed to update brand");
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteBrand = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Brand/DeleteBrand/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (!response.ok) throw new Error("Failed to delete brand");
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchBrandNameById = async (name) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Brand/GetBrandIdByName/${name}`
    );
    if (!response.ok) throw new Error("Failed to fetch brand name");
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};
